var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Header',{attrs:{"userInfo":_vm.userInfo}}),_c('SideNavBar'),_c('Loading'),_c('Notice'),_c('router-view',{key:_vm.$route.fullPath}),_c('Login'),_c('SearchModle'),_c('Sidebar'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }